/** A task's terms: every term the draft will use, as the Terminology panel reads them. */

import { get } from "@/services/api-client";
import type { TermsResponse } from "@patent-studio/api-types";

export function readTerms(taskId: string): Promise<TermsResponse> {
  return get<TermsResponse>(`/tasks/${taskId}/terms`);
}
